export default __webpack_public_path__ + "static/media/icon-search-2.8ff11345.svg";